export default __webpack_public_path__ + "static/media/alamo-material-1.dd96feeb.webp";